import { connect } from 'react-redux';
import InterviewSectionStart, { IProps } from './index';
import { ApplicationState } from '../../../../store';

const mapStateToProps = (state: ApplicationState): IProps => {
  return {
    config: state.student.config.Interview,
  };
};

export default connect(mapStateToProps)(InterviewSectionStart);
